import { Controller } from '@hotwired/stimulus';
import { bearingToMapAngle } from '../lib/direction_dial.js';
import {
  defaultEffectName,
  isDirectionalEffect,
  validAreaEffect,
  validDirection
} from '../lib/konva_map/area_effect_geometry.js';

export default class extends Controller {
  static values = { parentId: String, tokenSize: Number };
  static targets = [
    'name',
    'color',
    'type',
    'radiusFields',
    'cubeFields',
    'directionalFields',
    'widthFields',
    'directionalHint',
    'radius',
    'size',
    'side',
    'sideSize',
    'length',
    'lengthSize',
    'width',
    'widthSize',
    'direction',
    'directionSlider',
    'confirm'
  ];

  connect() {
    this.update();
  }

  update(event) {
    if (event?.currentTarget === this.directionSliderTarget) {
      this.directionTarget.value = this.directionSliderTarget.value;
    }
    this.directionSliderTarget.value = Math.round(Number(this.directionTarget.value));
    const radiusSelected = this.typeTarget.value === 'radius';
    const cubeSelected = this.typeTarget.value === 'cube';
    const lineSelected = this.typeTarget.value === 'line';
    const directionalSelected = isDirectionalEffect(this.effect);
    const radius = Number(this.radiusTarget.value);
    this.radiusFieldsTarget.hidden = this.radiusFieldsTarget.disabled = !radiusSelected;
    this.cubeFieldsTarget.hidden = this.cubeFieldsTarget.disabled = !cubeSelected;
    this.directionalFieldsTarget.hidden = this.directionalFieldsTarget.disabled = !directionalSelected;
    this.widthFieldsTarget.hidden = this.widthFieldsTarget.disabled = !lineSelected;
    this.confirmTarget.disabled = !validAreaEffect(this.effect);
    this.sizeTarget.textContent = `${radius} ft radius · ${radius * 2 + (this.tokenSizeValue || 0)} × ${radius * 2 + (this.tokenSizeValue || 0)} ft square`;
    this.sideSizeTarget.textContent = `${this.sideTarget.value} × ${this.sideTarget.value} ft square`;
    this.lengthSizeTarget.textContent =
      this.typeTarget.value === 'cone'
        ? `${this.lengthTarget.value} ft long · ${this.lengthTarget.value} ft wide at the end`
        : `${this.lengthTarget.value} ft`;
    this.widthSizeTarget.textContent = `${this.widthTarget.value} ft`;
    this.nameTarget.placeholder =
      radiusSelected || cubeSelected || directionalSelected ? defaultEffectName(this.effect) : 'Effect name';
    this.directionalHintTarget.textContent =
      this.typeTarget.value === 'cone'
        ? 'Starts one tile ahead of the caster. Each 5 ft row adds one tile, widening from 5 ft to the cone’s length.'
        : 'Starts one tile ahead of the caster and steps through whole tiles. Each grid tile is 5 ft.';
  }

  get effect() {
    const effectType = this.typeTarget.value;
    if (effectType === 'radius') return { effectType, radiusFeet: Number(this.radiusTarget.value) };
    if (effectType === 'cube') return { effectType, sideFeet: Number(this.sideTarget.value) };
    if (isDirectionalEffect({ effectType })) {
      const bearing = this.directionTarget.value === '' ? NaN : Number(this.directionTarget.value);
      return {
        effectType,
        lengthFeet: Number(this.lengthTarget.value),
        ...(effectType === 'line' ? { widthFeet: Number(this.widthTarget.value) } : {}),
        directionDegrees: validDirection(bearing) ? bearingToMapAngle(bearing) : NaN
      };
    }
    return { effectType };
  }

  confirm(event) {
    event.preventDefault();
    if (!validAreaEffect(this.effect)) return;
    this.dispatch('confirm', {
      detail: {
        ...this.effect,
        ...(this.parentIdValue ? { parentId: this.parentIdValue } : {}),
        name: this.nameTarget.value.trim() || defaultEffectName(this.effect),
        color: this.colorTarget.value
      }
    });
  }
}
